import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: 'index',
    component: Layout,
    children: [
      {
        name: 'index',
        path: 'index',
        component: () => import(/* webpackChunkName: "index" */ '@/views/index.vue'),
      },
    ],
  },
  {
    path: '/email',
    name: 'email',
    component: () => import(/* webpackChunkName: "index" */ '@/views/email.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
